import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'shared-core-expandable-card-content',
  imports: [],
  template: ` <ng-content /> `,
})
export class ExpandableCardContentComponent {
  @HostBinding('class')
  class = 'min-h-0';
}
